module.exports = __webpack_public_path__ + "static/media/WMATIC_DFYN.040f1bcd.svg";